@keyframes spin-anim {
  to {
    transform: rotate(360deg);
  }
}

.button-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 1rem 0;
}

.button-list :global(.rds-button),
.button-list .action-button {
  margin: 0.5rem 1rem 0.5rem 0;
}

.action-button {
  border: 2px solid transparent;
  border-radius: 1.5rem;
  padding: 0 1.5rem;
  height: 3rem;
  transition:
    background-color 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease;

  font-family: var(--rds-font-family-headlines);
  font-size: clamp(1.125rem, 1.125rem + 0vw, 1.125rem);
  font-weight: normal;
  line-height: 1.5;

  cursor: pointer;
  display: inline-flex;
  align-items: center;
  text-decoration: none;

  outline-offset: 4px;
}

.action-button:focus-visible {
  outline: 2px solid var(--rds-focus-outline-color, #0066cc);
}

.icon-only {
  justify-content: center;
  padding: 0;
  width: 3rem;
}

.icon-only-large {
  height: 4.5rem;
  width: 4.5rem;
  border-radius: 2.25rem;
}

.light {
  --btn-primary--bg: var(--rds-accent-color);
  --btn-primary--color: var(--rds-button-primary-fg);
  --btn-primary--active-bg: var(--rds-accent-color-dark);

  --btn-secondary--bg: transparent;
  --btn-secondary--color: var(--rds-foreground-primary);
  --btn-secondary--border-color: var(--rds-foreground-secondary);
  --btn-secondary--active-bg: var(--rds-foreground-primary);
  --btn-secondary--active-color: var(--rds-background-primary);

  --btn-tertiary--bg: var(--rds-foreground-overlay-soft);
  --btn-tertiary--color: var(--rds-foreground-primary);
  --btn-tertiary--hover-bg: var(--rds-foreground-primary);
  --btn-tertiary--hover-color: var(--rds-background-primary);
  --btn-tertiary--active-bg: var(--rds-foreground-tertiary);
  --btn-tertiary--active-color: var(--rds-foreground-primary);
  --btn-tertiary--selected-bg: var(--rds-background-primary);
  --btn-tertiary--selected-color: var(--rds-foreground-primary);
  --btn-tertiary--disabled-bg: var(--rds-foreground-overlay-soft);

  --link-color: var(--rds-foreground-primary);
}

.dark {
  --btn-primary--bg: var(--rds-button-primary-fg);
  --btn-primary--color: var(--rds-foreground-primary);
  --btn-primary--active-bg: var(--rds-foreground-tertiary);

  --btn-secondary--bg: var(--rds-accent-color);
  --btn-secondary--color: var(--rds-button-primary-fg);
  --btn-secondary--border-color: var(--rds-foreground-primary);
  --btn-secondary--active-bg: var(--rds-accent-color-dark);
  --btn-secondary--active-color: var(--rds-button-primary-fg);

  --btn-tertiary--bg: var(--rds-foreground-overlay-dark-soft);
  --btn-tertiary--color: var(--rds-button-primary-fg);
  --btn-tertiary--hover-bg: var(--rds-background-primary);
  --btn-tertiary--hover-color: var(--rds-foreground-primary);
  --btn-tertiary--active-bg: var(--rds-foreground-tertiary);
  --btn-tertiary--active-color: var(--rds-foreground-primary);
  --btn-tertiary--selected-bg: var(--rds-background-primary);
  --btn-tertiary--selected-color: var(--rds-foreground-primary);
  --btn-tertiary--disabled-bg: var(--rds-foreground-overlay-soft);

  --link-color: var(--rds-button-primary-fg);
}

.primary {
  color: var(--btn-primary--color);
  background-color: var(--btn-primary--bg);
}

.primary:hover,
.primary:active {
  background-color: var(--btn-primary--active-bg);
}

.primary[disabled] {
  background-color: var(--btn-primary--bg);
}

.secondary {
  color: var(--btn-secondary--color);
  background-color: var(--btn-secondary--bg);
  border-color: var(--btn-secondary--border-color);
}

.secondary:hover,
.secondary:active,
.secondary.selected {
  color: var(--btn-secondary--active-color);
  background-color: var(--btn-secondary--active-bg);
  border-color: transparent;
}

.secondary[disabled] {
  border-color: var(--btn-secondary--border-color);
}

.tertiary {
  color: var(--btn-tertiary--color);
  background-color: var(--btn-tertiary--bg);
}

.tertiary:hover {
  color: var(--btn-tertiary--hover-color);
  background-color: var(--btn-tertiary--hover-bg);
}

.tertiary:active {
  color: var(--btn-tertiary--active-color);
  background-color: var(--btn-tertiary--active-bg);
}

.tertiary.selected {
  color: var(--btn-tertiary--selected-color);
  background-color: var(--btn-tertiary--selected-bg);
}

.tertiary[disabled] {
  background-color: var(--btn-tertiary--disabled-bg);
}

.inline-link,
.inline-link-light {
  color: var(--link-color);
  background: transparent;
  border: none;
  text-decoration: underline;
  padding: 0;
  height: auto;
}

.inline-link:hover,
.inline-link-light:hover {
  text-decoration: none;
}

.inline-link-light {
  color: var(--rds-feedback-info);
}

a.inline-link-light {
  color: var(--rds-heading-accent);
}

.action-button[disabled],
.action-button[aria-busy] {
  color: var(--rds-foreground-secondary);
}

.action-button[disabled]:hover,
.action-button[aria-busy]:hover {
  color: var(--rds-foreground-secondary);
}

.action-button[aria-busy]::before {
  content: '';
  display: inline-block;
  vertical-align: middle;
  width: 1rem;
  height: 1rem;
  border: 1px solid;
  border-top: 1px solid rgba(0, 0, 0, 0);
  border-radius: 50%;
  margin-right: 0.5rem;
  animation: spin-anim 1s infinite linear;
}
